import { configureStore } from '@reduxjs/toolkit';
import { quizdbApi } from '../api/quizdbApi';
import { authReducer } from '../auth/AuthStore';

/**
 * Builds a fresh store. Used both by the app's single `store` instance below
 * and by tests that need their own isolated store (QZ-D8).
 */
export const createAppStore = () =>
  configureStore({
    reducer: {
      [quizdbApi.reducerPath]: quizdbApi.reducer,
      auth: authReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(quizdbApi.middleware),
  });

export const store = createAppStore();

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
